module.exports = __webpack_public_path__ + "6dea5c7aa2cd82176902737915773293.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/shengdi/jingdian/jingdian-bg.jpg
// module id = 1225
// module chunks = 0